import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

const TitleBar = ({ actions, title }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" enableColorOnDark color="default">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          {actions}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

TitleBar.propTypes = {
  actions: PropTypes.node,
  title: PropTypes.node,
};

export default TitleBar;
